import Badge from "plos/src/components/Badge/Badge";
import {
  badgeWrapper,
  newsHeaderTeamStyles,
  teamNameAbbr,
} from "./newsHeaderTeam.css";
import { NewsHeaderTeamProps } from "./types";

const NewsHeaderTeam = ({ team, isAwayTeam = false }: NewsHeaderTeamProps) => {
  const headerVariant = isAwayTeam ? "away" : "home";
  return (
    <span className={newsHeaderTeamStyles[headerVariant]}>
      <span>
        <abbr className={teamNameAbbr} title={team.name}>
          {team.short_name}
        </abbr>
      </span>
      <div className={badgeWrapper}>
        <Badge team={team} isPresentation />
      </div>
    </span>
  );
};

export default NewsHeaderTeam;
